export default __webpack_public_path__ + "static/media/United-States.9a082761.svg";